import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Text } from '@grandvisionhq/elements';

const TimeSlotsItem = (_param)=> {
    var { className , selected , label , onSelect  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "selected",
        "label",
        "onSelect"
    ]);
    return React.createElement("button", swcHelpers.extends({}, rest, {
        className: classnames('time-slots-item', className, {
            'time-slots-item--selected': selected
        }),
        role: "checkbox",
        "aria-checked": selected,
        onClick: onSelect,
        type: "button"
    }), /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        component: "span"
    }, label));
};

export { TimeSlotsItem as default };
//# sourceMappingURL=TimeSlotsItem.js.map
